import { useState, useCallback } from "react";
import { getAxios } from "../utils/axios";
const endpoint = "/inventory/storage";
export const useInventoryStorage = () => {
    const [storage, setStorage] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const mergeByUuid = (prev, next) => {
        if (!next?.uuid) {
            return prev;
        }
        const index = prev.findIndex((item) => item?.uuid === next.uuid);
        if (index === -1) {
            return [...prev, next];
        }
        const updated = [...prev];
        updated[index] = { ...updated[index], ...next };
        return updated;
    };
    const fetchAll = useCallback(async (filter) => {
        setLoading(true);
        setError(null);
        try {
            const params = new URLSearchParams();
            if (filter) {
                params.set("filter", JSON.stringify(filter));
            }
            params.set("offset", "0");
            params.set("limit", "100");
            const res = await getAxios().get(`${endpoint}?${params.toString()}`);
            setStorage(res.data);
        }
        catch (err) {
            setError(err.message || "Failed to fetch storage.");
        }
        finally {
            setLoading(false);
        }
    }, []);
    const create = async (payload, refetchFilter) => {
        const res = await getAxios().post(endpoint, payload);
        await fetchAll(refetchFilter);
        setStorage((prev) => mergeByUuid(prev, res.data));
        return res.data;
    };
    const update = async (uuid, payload, refetchFilter) => {
        const res = await getAxios().put(`${endpoint}/${uuid}`, payload);
        await fetchAll(refetchFilter);
        setStorage((prev) => mergeByUuid(prev, res.data));
        return res.data;
    };
    const patch = async (uuid, payload, refetchFilter) => {
        const res = await getAxios().patch(`${endpoint}/${uuid}`, payload);
        await fetchAll(refetchFilter);
        setStorage((prev) => mergeByUuid(prev, res.data));
        return res.data;
    };
    const remove = async (uuid, refetchFilter) => {
        const res = await getAxios().delete(`${endpoint}/${uuid}`);
        await fetchAll(refetchFilter);
        setStorage((prev) => prev.filter((item) => item?.uuid !== uuid));
        return res.data;
    };
    return {
        storage,
        loading,
        error,
        fetchAll,
        create,
        update,
        patch,
        remove,
    };
};
